import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { BarChart2 } from "lucide-react";
import { impactData } from "../../../../data/impact";
import "./Impact.css";

gsap.registerPlugin(ScrollTrigger);

const Impact = () => {
  const sectionRef = useRef(null);
  const leftRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const leftElements = leftRef.current.querySelectorAll(".animate-left");
      gsap.fromTo(
        leftElements,
        { opacity: 0, x: 50, y: 20 },
        {
          opacity: 1,
          x: 0,
          y: 0,
          duration: 0.8,
          stagger: 0.15,
          ease: "power3.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 70%",
            toggleActions: "play none none none",
            once: true,
          },
        },
      );

      const achievements = leftRef.current.querySelectorAll(
        ".impact-achievement",
      );
      gsap.fromTo(
        achievements,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.7,
          stagger: 0.15,
          ease: "power3.out",
          scrollTrigger: {
            trigger: leftRef.current,
            start: "top 65%",
            toggleActions: "play none none none",
            once: true,
          },
        },
      );

      gsap.fromTo(
        imageRef.current,
        { opacity: 0, x: -50, scale: 0.95 },
        {
          opacity: 1,
          x: 0,
          scale: 1,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 70%",
            toggleActions: "play none none none",
            once: true,
          },
        },
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="impact" ref={sectionRef}>
      <div className="impact__container">
        <div className="impact__right">
          <div className="impact__image" ref={imageRef}>
            <img src={impactData.image} alt="Our Impact" />
          </div>
        </div>

        <div className="impact__left" ref={leftRef}>
          <div className="impact__badge animate-left">{impactData.badge}</div>

          <div className="impact__icon-wrapper animate-left">
            <BarChart2 size={32} strokeWidth={1.5} />
          </div>

          <h2 className="impact__headline animate-left">
            {impactData.headline}
          </h2>

          <p className="impact__description animate-left">
            {impactData.description}
          </p>

          <div className="impact__achievements">
            {impactData.achievements.map((achievement, index) => (
              <div key={index} className="impact-achievement">
                <div className="impact-achievement__check">✓</div>
                <div className="impact-achievement__text">
                  {achievement.text}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Impact;
